import React, { useState } from 'react';
import { Image } from 'antd';
import cx from 'classnames';
import type { IMessage } from '@typing/wsui/getMessages';
import styles from './index.module.less';

interface IUserMessageProps {
    message: IMessage;
    onRetry?: (message: IMessage) => void;
}

const errorIcon = 'https://med-fe.bj.bcebos.com/fe-doctor-workbench/errorIcon.png';
const privacyIcon = 'https://med-fe.bj.bcebos.com/fe-doctor-workbench/%E5%AE%89%E5%85%A8icon.png';

/**
 * 用户消息组件
 * 支持纯文本和图文混合展示
 */
const UserMessage: React.FC<IUserMessageProps> = ({ message, onRetry }) => {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewIndex, setPreviewIndex] = useState(0);
    const text = message.sections[0]?.segments[0]?.content || '';
    const images = message.images;
    const hasImages = images && images.length > 0;
    const sendFailed = message.sendFailed;
    const failIcon = sendFailed ? (
        <button className={styles.failIcon} onClick={() => onRetry?.(message)} title="重新发送" type="button">
            <img src={errorIcon} width={20} height={20} alt="重新发送" />
        </button>
    ) : null;

    return (
        <>
            <div className={styles.bubbles}>
                {/* 图片气泡 */}
                {hasImages && (
                    <div className={styles.bubbleRow}>
                        {failIcon}
                        <div className={cx(styles.imageBubble, { [styles.singleImage]: images.length === 1 })}>
                            <div className={styles.imageArea}>
                                {images.map((img, index) => (
                                    <img
                                        key={index}
                                        src={img.icon || img.small || img.origin}
                                        alt=""
                                        className={styles.messageImage}
                                        onClick={() => {
                                            setPreviewIndex(index);
                                            setPreviewVisible(true);
                                        }}
                                    />
                                ))}
                            </div>
                            <div className={styles.privacyTip}>
                                <img src={privacyIcon} alt="" width={11.96} height={12} />
                                <span>平台保证隐私安全</span>
                            </div>
                        </div>
                    </div>
                )}
                {/* 文字气泡 */}
                {text && (
                    <div className={styles.bubbleRow}>
                        {failIcon}
                        <div className={styles.userBubble}>
                            <div className={styles.textContent}>{text}</div>
                        </div>
                    </div>
                )}
            </div>

            {/* 大图预览 */}
            {hasImages && (
                <Image.PreviewGroup
                    items={images.map((img) => img.origin)}
                    preview={{
                        visible: previewVisible,
                        current: previewIndex,
                        onChange: setPreviewIndex,
                        onVisibleChange: setPreviewVisible,
                    }}
                />
            )}
        </>
    );
};

export default UserMessage;
